import { ReactComponent as eco } from "./eco.svg"
import { ReactComponent as frosty } from "./frosty.svg"
import { ReactComponent as regular } from "./regular.svg"
import { ReactComponent as reflective } from "./reflective.svg"
import { ReactComponent as rollup_regular } from "./rollup_regular.svg"

const icons: IconMap = {
  eco,
  frosty,
  regular,
  reflective,
  rollup_regular,
}

export default icons
